import { useEffect, useRef, useState } from 'react';
import { isoDate } from '../api.js';

/**
 * „Бърз период" — двете колони Предишен/Текущ × ден/седмица/месец/година
 * от старата програма („Печалби от Търговската ни Дейност"). Смята
 * От/До дата и ги връща наведнъж — по-бързо от ръчно избиране в календара.
 */
const VIDOVE = ['ден', 'седмица', 'месец', 'година'];

/*
 * `d.toISOString().slice(0, 10)` беше тук преди и биеше грешно: в
 * България всеки час между полунощ и изгрев UTC се четеше като предишния
 * ден — „текущ месец" на 1-во число сутринта започваше от 31-во
 * миналия. Виж isoDate в api.js.
 */
const iso = isoDate;

/** Понеделник на седмицата, в която е d. */
function ponedelnik(d) {
  const x = new Date(d);
  const denOtNedelia = (x.getDay() + 6) % 7; // 0 = понеделник
  x.setDate(x.getDate() - denOtNedelia);
  return x;
}

function smetniPeriod(vid, koga) {
  const dnes = new Date();
  const minalo = koga === 'previous';

  if (vid === 'ден') {
    const d = new Date(dnes);
    if (minalo) d.setDate(d.getDate() - 1);
    return { from: iso(d), to: iso(d) };
  }
  if (vid === 'седмица') {
    const start = ponedelnik(dnes);
    if (minalo) start.setDate(start.getDate() - 7);
    const end = new Date(start);
    end.setDate(end.getDate() + 6);
    return { from: iso(start), to: iso(end) };
  }
  if (vid === 'месец') {
    let g = dnes.getFullYear();
    let m = dnes.getMonth();
    if (minalo) { m -= 1; if (m < 0) { m = 11; g -= 1; } }
    return { from: iso(new Date(g, m, 1)), to: iso(new Date(g, m + 1, 0)) };
  }
  // година
  const g = dnes.getFullYear() - (minalo ? 1 : 0);
  return { from: `${g}-01-01`, to: `${g}-12-31` };
}

export default function QuickPeriod({ onPick }) {
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    if (!open) return;
    function navun(e) {
      if (box.current && !box.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', navun);
    return () => document.removeEventListener('mousedown', navun);
  }, [open]);

  function izberi(vid, koga) {
    onPick(smetniPeriod(vid, koga));
    setOpen(false);
  }

  return (
    <span className="quick-period" ref={box}>
      {/*
        * Невидимо поле, колкото истинско input — само за да зададе
        * височината на реда. Бутонът е по-нисък от „От дата"/„До дата" до
        * него (нарочно, остава иконка); без нещо с истинската височина на
        * полетата до него той пада ту по-ниско, ту по-високо според това
        * какъв padding му се сложи на око. Точно както прави DateField със
        * своя истински текст-инпут до скритото си календарче.
        */}
      <input aria-hidden="true" tabIndex={-1} readOnly value=""
        style={{
          width: 0, minWidth: 0, padding: '7px 0', border: '1px solid transparent',
          background: 'transparent', flex: '0 0 auto',
        }} />
      <button type="button" title="Бърз период" onClick={() => setOpen((v) => !v)}>
        📆
      </button>
      {open && (
        <div className="quick-period-menu">
          <div className="quick-period-col">
            <div className="quick-period-head">Предишен</div>
            {VIDOVE.map((v) => (
              <button key={v} type="button" onClick={() => izberi(v, 'previous')}>{v}</button>
            ))}
          </div>
          <div className="quick-period-col">
            <div className="quick-period-head">Текущ</div>
            {VIDOVE.map((v) => (
              <button key={v} type="button" onClick={() => izberi(v, 'current')}>{v}</button>
            ))}
          </div>
        </div>
      )}
    </span>
  );
}
